export const contentPasteGo = {
  icon: 'content_paste_go',
  text: 'Режим вставки активен - нажмите Ctrl+V для загрузки файлов'
};

export const contentPaste = {
  icon: 'content_paste',
  text: 'Нажмите, чтобы включить вставку файлов через Ctrl+V'
};

export const notificationTexts = {
  NO_ALLOWED_EXTENSIONS: (extensions: string) => `Разрешены только файлы с расширениями: ${extensions}`,
  SOME_FILES_FILTERED: 'Некоторые файлы были отфильтрованы - недопустимые расширения',
} as const;
